import React from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { getControlTokens } from './controlTokens';

function ControlActionGroup({
  context = 'objectToolbar',
  children,
  justifyContent = 'flex-end',
  sx,
}) {
  const theme = useTheme();
  const tokens = getControlTokens(theme, context);

  return (
    <Box
      data-control-action-group={context}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent,
        gap: tokens.gap,
        flexWrap: 'wrap',
        flexShrink: 0,
        minHeight: tokens.height,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}

export default ControlActionGroup;
